<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<router-outlet></router-outlet>
<dcs-error #dcserror></dcs-error>
<Dcs-loader></Dcs-loader>
<dcs-lookup #dcslookup></dcs-lookup>
